import { render } from "./SideBar.vue?vue&type=template&id=2c3707a0&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=2c3707a0&scoped=true&lang=css"

import exportComponent from "D:\\Documentos\\GitHub\\FACTURAR\\ed_facturar_view\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3707a0"]])

export default __exports__